import { getLocalizedText } from "data/utils";

const ADVANCED_SEARCH_PARAMS = ["words", "phrase", "anyWords", "nonWords"];
const FILTER_SEARCH_PARAMS = [
    "ItemType",
    "Groesse",
    "Dateityp",
    "Geaendert_am",
    "Geaendert_von",
    "Erstellt_am",
    "Erstellt_von",
];

const KNOWN_PARAMS = [...ADVANCED_SEARCH_PARAMS, ...FILTER_SEARCH_PARAMS];

export const getParamsFromSearchText = (searchText) => {
    if (!searchText || typeof searchText === "string") return [];
    return Object.entries(searchText)
        .map(([key, value]) => {
            if (value === null) return null;
            return `${key}=${value}`;
        })
        .filter((v) => !!v);
};

export const getLocalizedSearchLabel = (label, params) => {
    if (label && label !== "N/A") return label;
    return getLocalizedText(
        params?.some((p) =>
            ADVANCED_SEARCH_PARAMS.includes(p.split("=", 2)[0])
        ) ?? false
            ? "$search:mask.searchText"
            : "$search:freetext.empty"
    );
};

export const getLocalizedParamLabel = (param) => {
    const key = param.split("=", 2)[0];
    if (!KNOWN_PARAMS.includes(key)) return key;
    return ADVANCED_SEARCH_PARAMS.includes(key)
        ? getLocalizedText(`$common:filter.SearchText.${key}`)
        : getLocalizedText(`$common:filter.${key}.name`);
};

export const getLocalizedParamTitle = (param, label) => {
    const key = param.split("=", 2)[0];
    if (!KNOWN_PARAMS.includes(key)) return label;
    return ADVANCED_SEARCH_PARAMS.includes(key)
        ? getLocalizedText(`$search:searchText.${key}`)
        : label;
};
